// added for unit test purpose only
module.exports = {
    b2B: { businessTypeCategoryMapping: null },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/b2B.js